import {
  CHARACTER_WHITESPACE,
  EMPTY_LIST,
} from '../../../../../constants/common'
import {
  getIsMockApplicantId,
  getRentalPortalApplicantIdentityLabel,
} from '../../../../RentalPortalApplicant'

import {
  APPLICANT_DECISION_ACTION,
  APPLICANT_DECISION_CONFLICT_KEY,
} from './ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionTransition,
  getIsApplicantDecisionSelfApproval,
  getIsApplicantScreeningStage,
  getIsApplicantSelectedStage,
} from './ApplicantDecisionPanel.utils'

function toApprovedApplicantIdentity(approvedApplicant) {
  const name = [approvedApplicant.first_name, approvedApplicant.last_name]
    .filter(Boolean)
    .join(CHARACTER_WHITESPACE)

  return {
    identity: { masked: !name, value: name },
    reference: approvedApplicant.reference,
  }
}

function getApplicantDecisionRefusalTooltip({ t, transition }) {
  return transition.approved_applicant
    ? t('RentalPortal.ApplicantDecisionListingApprovedNamedTooltipKey', {
        applicant: getRentalPortalApplicantIdentityLabel({
          applicant: toApprovedApplicantIdentity(transition.approved_applicant),
          t,
        }),
      })
    : t(
        APPLICANT_DECISION_CONFLICT_KEY[transition.reason] ??
          'RentalPortal.ApplicantProfileStageTransitionNotAllowedTooltipKey'
      )
}

// TODO: mock applicants serve no decision transitions
function toApplicantDecisionAction({ action, applicantData, t }) {
  const transition = getApplicantDecisionTransition({ action, applicantData })

  if (getIsMockApplicantId(applicantData?.id)) {
    return { key: action, tooltip: null }
  }

  return transition
    ? {
        key: action,
        tooltip: transition.permitted
          ? null
          : getApplicantDecisionRefusalTooltip({ t, transition }),
      }
    : null
}

export function getApplicantDecisionSelectActions({
  applicantData,
  isPreview,
  t,
}) {
  if (isPreview) {
    return EMPTY_LIST
  }

  const selectAction = toApplicantDecisionAction({
    action: APPLICANT_DECISION_ACTION.select,
    applicantData,
    t,
  })

  return getIsApplicantScreeningStage(applicantData) &&
    applicantData.permissions?.can_select &&
    selectAction
    ? [selectAction]
    : EMPTY_LIST
}

export function getApplicantDecisionApprovalActions({
  applicantData,
  currentUserId,
  isPreview,
  t,
}) {
  if (
    isPreview ||
    !getIsApplicantSelectedStage(applicantData) ||
    !applicantData.permissions?.can_approve
  ) {
    return EMPTY_LIST
  }

  const selfApprovalTooltip = getIsApplicantDecisionSelfApproval({
    applicantData,
    currentUserId,
  })
    ? t('RentalPortal.ApplicantDecisionSelectorBlockedTooltipKey')
    : null

  return [
    APPLICANT_DECISION_ACTION.approve,
    APPLICANT_DECISION_ACTION.rejectSelection,
  ]
    .map(action => toApplicantDecisionAction({ action, applicantData, t }))
    .filter(Boolean)
    .map(action => ({
      ...action,
      tooltip: selfApprovalTooltip ?? action.tooltip,
    }))
}
